import React from 'react';
import { HighchartsReactRefObject } from 'highcharts-react-official';

import Loading from '../../Loading';
import usePackedBubbleData from './usePackedBubbleData';
import PackedBubbleView from './PackedBubbleView';

const PackedBubbleContent = ({
  chartDefinition,
  chartRef,
  useSmallNoDataMessage,
}: {
  chartDefinition: V5ChartDefinition;
  chartRef: React.MutableRefObject<HighchartsReactRefObject | null>;
  useSmallNoDataMessage: boolean;
}) => {
  const { options, isNoData, isReady } = usePackedBubbleData({
    chartDefinition,
    chartRef,
  });

  if (!isReady) {
    return <Loading />;
  }

  return (
    <PackedBubbleView
      chartRef={chartRef}
      options={options!}
      isNoData={isNoData}
      useSmallNoDataMessage={useSmallNoDataMessage}
    />
  );
};

export default PackedBubbleContent;
